import { JobHistoryGrouped } from "./JobHistoryGrouped"

/**
 * Job History tab component displaying grouped Spark job runs by date.
 * Shows date cards with summary status and drill-down capability.
 *
 * @returns {JSX.Element} The JobHistoryTab component
 */
export function JobHistoryTab() {
  return <JobHistoryGrouped />
}
